<template>
  <div>
    <Tabs v-model="tab" class="mb-6" />
    <div v-show="tab === 0">
      <FormClient :id="id" view />
    </div>
    <div v-if="tab === 1">
      <TableDocs :api-params="{ client_id: id, type: 'QUOTE' }" type="Devis" api-type="quotes" number-prefix="DV" />
    </div>
    <div v-else-if="tab === 2">
      <TableDocs
        :api-params="{ client_id: id, type: 'INVOICE' }"
        type="Facture"
        hide-delete
        api-type="invoices"
        number-prefix="FA"
        payment-status
      />
    </div>
    <div v-else-if="tab === 3">
      <TableDocs
        :api-params="{ client_id: id, type: 'CREDIT_NOTE' }"
        type="Note de credit"
        api-type="credit-notes"
        number-prefix="NC"
      />
    </div>
  </div>
</template>

<script>
import TableDocs from '@/components/Table/Docs'
import FormClient from '@/components/Form/Client'
import Tabs from '@/components/UI/Atom/Tabs'
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import clone from 'just-clone'

export default {
  props: {
    id: [String, Number],
    view: String,
  },
  components: {
    Tabs,
    FormClient,
    TableDocs,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const tabValue = parseInt(route.query.tab || 0, 10)
    const tab = ref(tabValue > 0 ? tabValue : 0)
    watch(tab, currentTab => {
      const currentQuery = clone(route.query)
      delete currentQuery.tab
      delete currentQuery.page
      router.replace({
        query: {
          tab: currentTab > 0 ? currentTab : undefined,
          page: currentTab > 0 ? route.query.page : undefined,
          ...currentQuery,
        },
      })
    })
    return { tab }
  },
}
</script>

<style></style>
